var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowShortIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6px",
    height: "10px",
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "right-arrow--short-icon--grey.85d88037") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Emergentes-Mobil",
    transform: "translate(-347.000000, -1144.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(6.000000, 1023.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(22.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-arrow--short-icon--grey.85d88037",
    transform: "translate(319.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.222721487,1.17076468 C1.69515899,2.4974314 3.16759658,3.82391274 4.6402216,5.15057945 C5.30847162,5.75261647 6.30597138,4.7731722 5.63453388,4.16835737 C4.16190886,2.84169066 2.68947148,1.5152092 1.21703398,0.188542485 C0.548783958,-0.413494527 -0.448528498,0.565949857 0.222721487,1.17076468 L0.222721487,1.17076468 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62578408,4.1683573 C3.16272155,5.6131721 1.6998465,7.05817196 0.23697149,8.50317201 C-0.404653497,9.13706091 0.589658953,10.119098 1.23147146,9.48520908 C2.69434647,8.04039428 4.15722135,6.59557959 5.62009636,5.15057954 C6.26190887,4.51669064 5.26759658,3.5344684 4.62578408,4.1683573 L4.62578408,4.1683573 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowShortIconGrey);
export default __webpack_public_path__ + "static/media/right-arrow--short-icon--grey.97652b345441564d10127106043410bf.svg";
export { ForwardRef as ReactComponent };